export async function getBillingInfo() {
  try {
    const response = await fetch(process.env.REACT_APP_API_HOST + "billing/plans", {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("tokenLida"),
      },
    })

    if (!response.ok) {
      throw new Error("Failed to fetch billing information")
    }

    return await response.json()
  } catch (error) {
    console.error("Error fetching billing information:", error)
    return null
  }
}

